import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import reportsLineChartData from "layouts/Dashboards/data/reportsLineChartData";
import Projects from "layouts/Dashboards/components/Projects";
import OrdersOverview from "layouts/Dashboards/components/OrdersOverview";
import { useContext, useEffect, useState } from "react";
import { LoginFormContext } from "context/LoginFormContext";
import { dashboardCountApi } from "Apis/dashboard";
import { MdBusiness, MdEvent, MdOutlinePostAdd } from "react-icons/md";
import { IoMdHeart } from "react-icons/io";
import { FaRegCalendar } from "react-icons/fa";
import { MdPeople } from "react-icons/md";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const { modules, isLoading } = useContext(LoginFormContext);
  const [count, setCount] = useState();

  const dashboardCount = async () => {
    const response = await dashboardCountApi();
    if (response?.status === 200) {
      setCount(response?.data?.data);
    }
  };
  const hasPermission = modules.some(
    (module) =>
      ["Member", "Business", "Matrimonial"].includes(module?.name) &&
      module.permissions?.read_access
  );

  const eventbookingPermission = modules.some(
    (module) => ["Booking", "Event"].includes(module?.name) && module.permissions?.read_access
  );

  useEffect(() => {
    dashboardCount();
  }, []);

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon={<MdPeople />}
                  title="Members"
                  count={count?.members}
                  // percentage={{
                  //   color: "success",
                  //   amount: "+3%",
                  //   label: "than last month",
                  // }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon={<MdBusiness />}
                  title="Businesses"
                  count={count?.bussiness}
                  // percentage={{
                  //   color: "success",
                  //   amount: "+55%",
                  //   label: "than lask week",
                  // }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="#808080"
                  icon={<MdPeople />}
                  title="Committee "
                  count={count?.committee}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon={<MdEvent />}
                  title="Events"
                  count={count?.events}
                  // percentage={{
                  //   color: "success",
                  //   amount: "+1%",
                  //   label: "than yesterday",
                  // }}
                />
              </MDBox>
            </Grid>
          </Grid>

          <Grid container spacing={3} marginY="10px">
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="#F44336"
                  icon={<IoMdHeart />}
                  title="Matrimonials"
                  count={count?.matrimonials}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon={<FaRegCalendar />}
                  title="Bookings"
                  count={count?.bookings}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="#673AB7"
                  icon={<MdOutlinePostAdd />}
                  title="Posts"
                  count={count?.posts}
                />
              </MDBox>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            {hasPermission && (
              <Grid item xs={12} md={6} lg={eventbookingPermission ? 8 : 12}>
                <Projects />
              </Grid>
            )}
            {eventbookingPermission && (
              <Grid item xs={12} md={6} lg={hasPermission ? 4 : 12} paddingBottom={{ xs: "20px" }}>
                <OrdersOverview />
              </Grid>
            )}
          </Grid>
        </MDBox>
        {/* <Footer /> */}
      </DashboardLayout>
    )
  );
}

export default Dashboard;
